import React from 'react'

class WinnerNoti extends React.Component {
    dateFormat = ddt => {
        let dd = ddt
        if (dd === null) return '개별 연락 예정'
        dd = dd.split(' ')
        const d = dd[0].split('-')
        let t = dd[1] ? dd[1] : '00:00:00'
        t = t.split(':')
        dd = new Date(d[0], d[1] - 1, d[2], t[0], t[1], t[2])
        const week = ['일', '월', '화', '수', '목', '금', '토']
        return `${dd.getMonth() + 1}월 ${dd.getDate()}일 (${week[dd.getDay()]})`
    }

    render() {
        const v = this.props.data
        return (
            <div className="evtGoods req">
                <p className="goodsTit">꼭 확인하세요!</p>
                <div className="leftReq">
                    <p>
                        <font className="icon-calendar">
                            &nbsp;
                            <b className="clrpont3">당첨자 댓글 마감일</b>
                        </font>
                        <em>&nbsp;{this.dateFormat(v.dt_ed_win_cmt)}</em>
                    </p>
                    <p>
                        <font className="icon-calendar">
                            &nbsp;
                            <b className="clrpont3">경품 발송 예정일</b>
                        </font>
                        <em>&nbsp;{this.dateFormat(v.dt_due_gift)}</em>
                    </p>
                </div>
                <div className="rightReq decoList">
                    <h3>당첨자 주의사항</h3>
                    <b className="clrpont3">당첨자는 경품을 받을 주소, 성함, 연락처를 비밀 댓글로 남겨주세요.</b>
                    <p>댓글 마감일까지 정확한 정보를 남기지 않은 경우 당첨이 취소됩니다.</p>
                    <p>5만원 초과 경품에 대한 제세공과금(22%)은 당첨자 부담입니다.</p>
                    <p>발송된 경품에 대해서는 불량으로 인한 교환 및 A/S는 제공되지 않습니다.</p>
                </div>
            </div>
        )
    }
}
export default WinnerNoti
